module.exports = __webpack_public_path__ + "47d101a0b43996a9c600816cf2107742.svg";